// Starts Application Insights, if a key is configured.
//
// `initializeAppInsights` has existed since the telemetry work but was never
// called from anywhere, so every trace the app has emitted since — including
// the Master Piece List reconnection instrumentation added in bb65a73 — went
// nowhere. That is why the Premier login investigation is being done by
// reading container logs by hand.
//
// Two deliberate guards:
//
//   1. `initializeAppInsights` THROWS when the instrumentation key is missing,
//      and the build pipeline does not currently supply VITE_APP_INSIGHTS_KEY
//      (it appears only in .env.example). So the key is checked first and the
//      whole thing is a no-op without it.
//   2. Everything is wrapped. Telemetry must never be able to stop the app
//      from starting — an outage caused by the tool meant to diagnose outages
//      is the worst possible trade.

import { initializeAppInsights } from './appInsights';

export const startAppInsights = (): void => {
  const instrumentationKey = import.meta.env?.VITE_APP_INSIGHTS_KEY as string | undefined;

  if (!instrumentationKey) {
    // Expected until the key reaches the pipeline. Logged once, quietly, so
    // there is something to see when someone asks why there is no telemetry.
    console.info('[telemetry] VITE_APP_INSIGHTS_KEY not set — Application Insights disabled.');
    return;
  }

  try {
    initializeAppInsights({
      instrumentationKey,
      enableAutoRouteTracking: true,
    });
    console.info('[telemetry] Application Insights initialized.');
  } catch (error) {
    console.error('[telemetry] Application Insights failed to initialize', error);
  }
};
